export default "__VITE_ASSET__DWfVqPdR__"